/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const searchBuildings = /* GraphQL */ `
  query SearchBuildings(
    $filter: SearchableBuildingFilterInput
    $sort: [SearchableBuildingSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableBuildingAggregationInput]
  ) {
    searchBuildings(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        name
        accountName
        address
        address2
        city
        state
        accountId
        postalCode
        country
        crmCustId
        floorArea
        tz
        connectionToleranceInMins
        salesOfficeName
        salesOfficeId
        salesOfficeCode
        offeringCodes
        offerings {
          items {
            name
            gracePeriod
            endDate
            startDate
            code
            status
            isActive
          }
        }
        deviceConnectivity
        deviceConnection {
          items {
            deviceId
            connectionTimeUTC
            connectionTimeLocal
            connectionLossTolerance
            buildingId
            id
          }
        }
        devices(filter: { isActive: { eq: 1 } }) {
          items {
            id
            deviceId
            type
            name
            connectionStatus
            remoteAccessStatus
            serial
          }
        }
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
            }
          }
        }
      }
    }
  }
`
export const getBuilding = /* GraphQL */ `
  query GetBuilding($id: ID!) {
    getBuilding(id: $id) {
      id
      name
      address
      city
      state
      postalCode
      country
      crmCustId
      floorArea
      collectedDataTime
      lat
      long
      deviceConnection {
        items {
          connectionTimeUTC
          connectionTimeLocal
        }
      }
      tz
      accountName
      accountId
      salesOfficeName
      salesOfficeId
      salesOfficeCode
      imageUrl
      offeringCodes
      offerings {
        items {
          name
          gracePeriod
          endDate
          startDate
          code
          status
          isActive
        }
      }
    }
  }
`
export const buildingWeatherInfo = /* GraphQL */ `
  query getWeatherInfo($buildingId: ID!) {
    listWeatherTimeSeriesData(
      buildingId: $buildingId
      limit: 1
      sortDirection: DESC
    ) {
      items {
        buildingId
        dateTime
        data
      }
    }
  }
`
export const listBuildings = /* GraphQL */ `
  query ListBuildings(
    $filter: ModelBuildingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBuildings(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        address
        city
        state
        postalCode
        country
        lat
        long
        crmCustId
        accountId
        floorArea
        tz
        offerings {
          items {
            id
            name
          }
        }
      }
      nextToken
    }
  }
`

export const getBuildingsTotal = `query getBuildingsTotal {
  getTableDetails(tableNames: ["Building"])
}`

export const GET_LOCATION_TIMEZONE = `query GET_LOCATION_TIMEZONE($lat: String, $long: String, $timestamp: String) {
  getLocationTimezone(lat: $lat, long: $long, timestamp: $timestamp)
  }
`
